import { Controller } from 'stimulus'

# Delegate to App.Views.Events.TicketFieldsView.
export default class extends Controller
  @targets: []

  initialize: ->
    new App.Views.Events.TicketFieldsView
      el: @element
      model: new Backbone.Model($(@element).data('model'))